const base_url = "https://landing.pikkat.com"

export default base_url